// extracted by mini-css-extract-plugin
module.exports = {"FormContainer":"CompanyStoreSettingForm_FormContainer__M3hQk","InvalidFeedback":"CompanyStoreSettingForm_InvalidFeedback__Ux7vt"};